import React from "react";
import styled from "styled-components";

const Heading = styled.h3`
  width: 100%;
  margin: 15px 0;
  padding: 5px 10px;
  color: #828282;
  background: #f2f2f2;
`;

function PreferenceHeading({ title }) {
  return <Heading>{title}</Heading>;
}

export { PreferenceHeading };
